export default __webpack_public_path__ + "static/media/08_slanisko-min.1efd9e9d.jpg";